module.exports = __webpack_public_path__ + "static/baker1-25515ef3726d603661b4aa854dadf01c.jpg";